<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="单品式管理" name="device">
                <swb-cmpr-table :dataLists="dataLists" :comnColNames="comnColNames" :cmprColNames="cmprColNames" :dataColumns="dataColumns" :comnColsTitle="comnColsTitle" :ukFunc="getDatumUk" :sortFunc="sortDatum" :dataColTextFunc="getDataColText"></swb-cmpr-table>
            </el-tab-pane>
            <el-tab-pane label="批量式管理" name="durable">
                <swb-cmpr-table :dataLists="dataLists_durable" :comnColNames="comnColNames" :cmprColNames="cmprColNames_durable" :dataColumns="dataColumns" :comnColsTitle="comnColsTitle" :ukFunc="getDatumUk" :sortFunc="sortDatum" :dataColTextFunc="getDataColText"></swb-cmpr-table>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import assetVchrApi from '../../api/assetVchr';

    import SwbCmprTable from '../ctrl/CmprTable'
    Vue.regist(SwbCmprTable);

    export default {
        name: 'swb-asset-stock-check-contrast',
        props: {
            voucherIds: {
                type: Array
            }
        },
        data: function () {
            return {
                activeName: 'device',
                // 设备配置
                dataLists: [],
                comnColNames: ['title', 'tmpNo', 'catName', 'brandName', 'modelSpec', 'theUnit', 'batchNo'],
                cmprColNames: ['checked', 'checkTime', 'checkerName', 'checkMemo', 'handleMemo'],
                dataColumns: [{
                    name: 'tmpNo',
                    title: '编号',
                    align: 'center',
                    width: 250
                }, {
                    name: 'title',
                    title: '名称',
                    align: 'left',
                    width: 200,
                    color: '#000'
                }, {
                    name: 'catName',
                    title: '分类',
                    width: 150
                }, {
                    name: 'brandName',
                    title: '品牌',
                    width: 150
                }, {
                    name: 'modelSpec',
                    title: '规格',
                    width: 200
                }, {
                    name: 'theUnit',
                    title: '单位',
                    width: 50
                }, {
                    name: 'batchNo',
                    title: '批次',
                    width: 100
                }, {
                    name: 'durable',
                    title: '批量',
                    align: 'center',
                    width: 50,
                    color: 'blue'
                }, {
                    name: 'checked',
                    title: '盘点状态',
                    width: 100,
                    color: function (value, datum) {
                        if(datum == null) {//表头
                            return null;
                        }
                        let checked = datum['checked'];
                        if(checked) {
                            let physicalState = datum['physicalState'];
                            if(physicalState == 0 || physicalState == -1) {
                                return "#00FF00";
                            } else {
                                return datum['handled'] ? '#000' : '#F00';
                            }
                        } else {
                            return '#000';
                        }
                    }
                }, {
                    name: 'checkTime',
                    title: '盘点时间',
                    align: 'center',
                    width: 150
                }, {
                    name: 'checkerName',
                    title: '盘点人',
                    width: 100
                }, {
                    name: 'checkMemo',
                    title: '情况描述',
                    width: 150
                }, {
                    name: 'handleMemo',
                    title: '异常处理备注',
                    width: 100
                }
                    // 耐耗品
                    , {
                        name: 'physicalState',
                        title: '盘点状态',
                        width: 100,
                        color: function (value, datum) {
                            if(datum == null) {//表头
                                return null;
                            }
                            let checked = datum['checked'];
                            if(checked) {
                                let checkedDelta = datum['checkedDelta'];
                                if(checkedDelta == 0) {
                                    return "#00FF00";
                                } else {
                                    return '#F00';
                                }
                            } else {
                                return '#000';
                            }
                        }
                    }, {
                        name: 'checkedQuantity',
                        title: '盘点数量',
                        align: 'right',
                        width: 80
                    }, {
                        name: 'checkedDelta',
                        title: '盘点差值',
                        align: 'right',
                        width: 80
                    }
                ],
                // 耐用品配置
                dataLists_durable: [],
                cmprColNames_durable: ['physicalState', 'checkedQuantity', 'checkedDelta', 'checkTime', 'checkerName', 'checkMemo'],
                comnColsTitle: '资产信息',
                // 其他
                dataItemList_all: [],
                dataItemList_durable_all: []
            }
        },
        created: function () {
            this.getVoucherListByVoucherIds();
        },
        methods: {
            handleClick(tab, event){
                if(tab.name == 'device' && this.dataItemList_all.length <= 0) {
                    Toast.show("没有资产信息");
                }
                if(tab.name == 'durable' && this.dataItemList_durable_all.length <= 0) {
                    Toast.show("没有资产信息");
                }
            },
            getVoucherListByVoucherIds(){
                let self = this;
                let postData = {};
                postData.ids = self.voucherIds;
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceStockCheckVoucherListByIds(self.voucherIds, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let voucherList = result.data;
                        self.toDataLists(voucherList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toDataLists(voucherList){
                let self = this;
                let dataLists = [];
                let dataLists_durable = [];
                let dataItemList_all = [];
                let dataItemList_durable_all = []
                voucherList.forEach(function (voucher) {
                    let dataItemList = [];
                    let dataItemList_durable = [];
                    let itemList = voucher.itemList;
                    if(!Utils.isNoB(itemList)) {
                        itemList.forEach(function (item) {
                            if(item.durable) {
                                dataItemList_durable.add(item);
                            } else {
                                dataItemList.add(item);
                            }
                        });
                    }
                    dataLists.add({
                        colsTitle: voucher.title,
                        dataList: dataItemList
                    });
                    dataLists_durable.add({
                        colsTitle: voucher.title,
                        dataList: dataItemList_durable
                    });
                    dataItemList_all.add(dataItemList);
                    dataItemList_durable_all.add(dataItemList_durable);
                });
                self.dataLists = dataLists;
                self.dataLists_durable = dataLists_durable;
                self.dataItemList_all = dataItemList_all;
                self.dataItemList_durable_all = dataItemList_durable_all;
                if(dataItemList_all.length <= 0) {
                    self.activeName = 'durable';
                }
            },
            getDatumUk(datum) {
                return datum['deviceXId'] + ':' + datum['durable'];
            },
            sortDatum(datum1, datum2) {
                let tmpValue = 0;
                tmpValue = datum1['catName'] == datum2['catName'] ? 0 : (datum1['catName'] < datum2['catName'] ? -1 : 1);
                if(tmpValue == 0) {
                    tmpValue = datum1['brandName'] == datum2['brandName'] ? 0 : (datum1['brandName'] < datum2['brandName'] ? -1 : 1);
                    if(tmpValue == 0) {
                        tmpValue = datum1['modelSpec'] == datum2['modelSpec'] ? 0 : (datum1['modelSpec'] < datum2['modelSpec'] ? -1 : 1);
                        if(tmpValue == 0) {
                            tmpValue = datum1['batchNo'] == datum2['batchNo'] ? 0 : (datum1['batchNo'] < datum2['batchNo'] ? -1 : 1);
                        }
                    }
                }
                //
                return tmpValue;
            },
            getDataColText(datum, colName) {
                let checked = datum['checked'];
                if(colName == 'checked') {
                    if(checked) {
                        let physicalState = datum['physicalState'];
                        if(physicalState == 0) {
                            return "正常";
                        } else if(physicalState == -1){
                            return "无实物";
                        } else {
                            return datum['handled'] ? "异常已处理" : "异常未处理";
                        }
                    } else {
                        return "未盘";
                    }
                }
                if(colName == 'physicalState') {
                    if(checked) {
                        let checkedDelta = datum['checkedDelta'];
                        if(checkedDelta == 0) {
                            return "正常";
                        } else if(checkedDelta > 0) {
                            return "盘盈";
                        } else {
                            return "盘亏";
                        }
                    } else {
                        return "未盘";
                    }
                }
                if(colName == 'checkedQuantity') {
                    if(checked) {
                        return datum['checkedQuantity'];
                    } else {
                        return "";
                    }
                }
                if(colName == 'checkedDelta') {
                    if(checked) {
                        return datum['checkedDelta'];
                    } else {
                        return "";
                    }
                }
                return datum[colName];
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetStockCheckContrast.vue